import type { Theme } from '@mui/material';

export const styles = {
  wrapper: (hasError: boolean) => (theme: Theme) => ({
    outline: hasError ? `2px solid ${theme.colors.error[600]}` : 'none',
    width: '100%',
    height: '100%',
  }),

  grid: {
    width: '100%',
    height: '100%',
  },

  button: (theme: Theme) => ({
    height: '100%',
    width: '100%',
    backgroundColor: theme.colors.neutral[200],

    '&:hover:not(:disabled)': {
      backgroundColor: theme.colors.neutral[300],
    },
  }),
};
